import { render, staticRenderFns } from "./PrimaryHud.vue?vue&type=template&id=67d77fc2&"
import script from "./PrimaryHud.vue?vue&type=script&lang=js&"
export * from "./PrimaryHud.vue?vue&type=script&lang=js&"
import style0 from "./PrimaryHud.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports